// extracted by mini-css-extract-plugin
export var aboveInput = "_h3-0";
export var actionButton = "_h3-5";
export var actionButtonContainer = "_h3-1";
export var actionIcon = "_h3-6";
export var aiInfoContainer = "_h3-2";
export var attachmentWrapper = "_h3-7";
export var bold = "_h3-3";
export var checkIcon = "_h3-8";
export var clickingRecipientBar = "_h3-11";
export var commentThreadSwitch = "_h3-a";
export var draftImage = "_h3-b";
export var draftImageContainer = "_h3-c";
export var draftImages = "_h3-e";
export var editButton = "_h3-g";
export var editor = "_h3-f";
export var editorContainer = "_h3-y";
export var editorErrorTooltipWrapper = "_h3-9";
export var headerDivider = "_h3-h";
export var icon = "_h3-i";
export var info = "_h3-j";
export var internal = "_h3-n";
export var internalDivider = "_h3-k";
export var internalMessage = "_h3-l";
export var messageInputCard = "_h3-m";
export var messageInputForm = "_h3-o";
export var messageInputFormInternal = "_h3-p";
export var options = "_h3-q";
export var publicMessageCustomer = "_h3-s";
export var publicMessageMerchant = "_h3-r";
export var removeImageButton = "_h3-d";
export var replyButtons = "_h3-t";
export var showSignatureButton = "_h3-u";
export var spinner = "_h3-v";
export var verticalButtonDivider = "_h3-4";
export var visibilitySelector = "_h3-w";
export var warning = "_h3-x";
export var wrappingText = "_h3-z";
export var writingInternalNoteTopBorder = "_h3-10";